import { mapGetters } from 'vuex'
import TourDialog from '@/agilis/components/TourDialog/TourDialog.vue'

export default {
  name: 'TourLauncherMixin',

  components: {
    Tour: () => import(/* webpackChunkName: "vue-tour" */'@/agilis/components/Tour/Tour.vue'),
    TourDialog
  },

  data () {
    return {
      show: false
    }
  },

  computed: {
    ...mapGetters({
      currentTour: 'tourStore/currentTour',
      tour: 'tourStore/tour',
      userShowTours: 'userDataStore/showTours'
    }),

    showTour () {
      // OLDTOUR return this.userShowTours && this.show && this.tour
      return this.show && this.tour
    }
  },

  watch: {
    currentTour () {
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
